export default class TaskTemplatesService {
  processing = false;
  query = '';

  constructor(Authentication, EventCollection, AlertService, SlingApi, sdk, $rootScope) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      EventCollection,
      AlertService,
      SlingApi,
      sdk,
      $rootScope,
    });

    this.TaskTemplatesCollection = sdk('models/TaskTemplatesCollection');
    this.initEventListeners();
  }

  initEventListeners() {
    this.$rootScope.$on('socket:taskTemplate:sync', async () => {
      this.TaskTemplatesCollection.clearCache();
      await this.loadTemplates();
      this.search(this.query);
    });
    this.Authentication.onOrgUpdate((org, oldOrg) => {
      if (org.subscriptionLevel !== oldOrg.subscriptionLevel) {
        this.TaskTemplatesCollection.clearCache();
      }
    });
  }

  async loadTemplates() {
    if (!this.TaskTemplatesCollection.allTemplates) {
      this.processing = true;
      const templateList = await this.SlingApi.getTaskTemplates();
      this.TaskTemplatesCollection.setTemplates(templateList);
      this.processing = false;
    }

    return this.TaskTemplatesCollection.allTemplates;
  }

  async loadTemplateDetails(templateId) {
    await this.loadTemplates();

    const template = this.findById(templateId);
    if (!template) {
      this.AlertService.danger("Could not find the template you're looking for");
    }
    return template;
  }

  get allTemplates() {
    return this.TaskTemplatesCollection.allTemplates;
  }

  get templates() {
    return this.filteredTemplates || this.allTemplates;
  }

  async create(template) {
    this.processing = true;
    const result = await this.SlingApi.createTaskTemplate(template);
    this.onCreateSuccess(result);
  }

  onCreateSuccess(result) {
    this.TaskTemplatesCollection.add(result);
    this.search(this.query);
    this.processing = false;
    return result;
  }

  async edit(template, updateTaskInstances) {
    this.processing = true;
    const result = await this.SlingApi.editTaskTemplate(template, { updateTaskInstances });
    this.onEditSuccess(result);
  }

  onEditSuccess(result) {
    this.TaskTemplatesCollection.edit(result);
    this.processing = false;
    this.search(this.query);
    return result;
  }

  async remove(templateId) {
    this.processing = true;
    const id = Number(templateId);
    await this.SlingApi.deleteTaskTemplate(id);
    this.removeTemplateFromConnectedShifts(id);
    this.TaskTemplatesCollection.remove(id);
    this.search(this.query);
    this.processing = false;
  }

  search(searchText = '') {
    this.query = searchText.toLowerCase();
    this.filteredTemplates = this.TaskTemplatesCollection.findByTitle(this.query);
    return this.filteredTemplates;
  }

  resetFilters() {
    this.query = '';
    this.filteredTemplates = null;
  }

  findById(templateId) {
    return this.TaskTemplatesCollection.findById(templateId);
  }

  prepareTemplateForSave(template) {
    return {
      ...template,
      subtasks: template.subtasks
        .filter((subtask) => subtask.title.trim())
        .map((subtask) => subtask.title),
    };
  }

  async filterDeletedTaskTemplates(taskTemplates) {
    if (!taskTemplates?.length) {
      return [];
    }

    const templates = await this.loadTemplates();
    return taskTemplates.filter(({ id }) =>
      templates.some((template) => template.id === id && !template.deleted)
    );
  }

  // @sideEffects: shifts in EventCollection might get mutatated when using this method
  removeTemplateFromConnectedShifts(taskTemplateId) {
    this.EventCollection.allEvents
      ?.filter(
        (event) =>
          event.type === 'shift' && event?.taskTemplates.some(({ id }) => id === taskTemplateId)
      )
      .forEach((shift) => {
        shift.taskTemplates = shift.taskTemplates.filter(
          (template) => template.id !== taskTemplateId
        );
      });
  }
}
